import $ from "jquery";
import _ from "lodash";
import { modal } from "./modal";
class Dialogs {
    showDialog(type, options) {
        return new Promise((resolve) => {
            const clone = $($("[data-dialog]").html());
            clone.find("[data-dialog-title]").text(options.title || "Confirm");
            clone.find("[data-dialog-accessible-title]").attr("aria-label", options.title || "Confirm");
            clone
                .find("[data-dialog-message], [data-dialog-value] label")
                .html(options.message);
            if (type === "alert") {
                clone.find("[data-dialog-negative-action]").addClass("hidden");
                clone.find("[data-dialog-positive-action]").text("OK");
            }
            if (type === "prompt") {
                clone.find("[data-dialog-message]").addClass("hidden");
                clone.find("[data-dialog-positive-action]").text("OK");
            }
            else {
                clone.find("[data-dialog-value]").addClass("hidden");
            }
            modal.once("hide", (m) => {
                if (_.some($("[data-dialog-title]", m)))
                    resolve({ result: "negative" });
            });
            setTimeout(() => {
                const newModal = modal.show(clone);
                if (type === "prompt")
                    setTimeout(() => newModal.find("[data-dialog-value] input").trigger("focus"), 100);
                newModal.find("[data-dialog-positive-action]").on("click", () => {
                    resolve({
                        result: "positive",
                        value: newModal.find("[data-dialog-value] input").val(),
                    });
                    modal.hide();
                });
            });
        });
    }
    blockUi() {
        const html = $("[data-dialog-ui-blocker]").html();
        setTimeout(() => (this.uiBlockerModal = modal.show(html)));
    }
    unblockUi() {
        this.uiBlockerModal && modal.hide(this.uiBlockerModal);
    }
}
export const dialogs = new Dialogs();
